/** @jsx jsx */
// eslint-disable-next-line import/no-unresolved
import { Flex } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';
import ProductFeatureIcon from '../ProductsList/ProductFeatureIcon';

export default function ProductCardFeatures({ product, ...rest }) {
  if (!product.features?.length) return null;
  return (
    <Flex sx={{ width: '100%', justifyContent: 'flex-end' }} {...rest}>
      {product.features?.map((type) => (
        // Product features have to be queried separately by the parent.
        <ProductFeatureIcon key={type} variant="onPrimary" type={type} />
      ))}
    </Flex>
  );
}
